var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.33301 2.80025L5.39967 3.72206L7.13301 5.43399H0.333008V6.75087H7.13301L5.39967 8.4628L6.33301 9.38461L9.66634 6.09243L6.33301 2.80025ZM12.333 10.7015H6.99967V12.0184H12.333C13.0663 12.0184 13.6663 11.4258 13.6663 10.7015V1.48338C13.6663 0.759097 13.0663 0.166504 12.333 0.166504H6.99967V1.48338H12.333V10.7015Z",
    fill: "#F0F0F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout_icon.e4841b7c4ea3b87e0e9bea5127a0b1d8.svg";
export { ForwardRef as ReactComponent };